import React from "react";

export default function AppFormikRadio(props) {
    const {
        formik,
        labelClass,
        formikFieldName,
        checkedText,
        unCheckedText,
    } = props;

    return (
        <label
            className={`st-switch-input d-inline-flex ${labelClass ? labelClass : ""
                }`}
        >
            <input
                type="checkbox"
                className="d-none"
                id={formikFieldName}
                checked={
                    formik.getFieldProps(formikFieldName).value ? true : false
                }
                onChange={() =>
                    formik.setFieldValue(
                        formikFieldName,
                        !formik.getFieldProps(formikFieldName).value
                    )
                }
            />
            {/* round */}
            <span className="round-outer">
                <span className="round d-block"></span>
            </span>
            {/* text */}
            <span className="text ms-2 position-relative st-fs-13 st-fw-600">
                {formik.values[formikFieldName] ? checkedText : unCheckedText}
            </span>
        </label>
    );
}
